import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1b6fd660&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./popupConfirmWizardExit.styles.scss?vue&type=style&index=0&id=1b6fd660&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6fd660",
  null
  
)

export default component.exports